import {
  checkoutSessionThunk,
  customerPortalThunk,
  subscriptionsListThunk,
} from "thunks/stripe";
import { notificationDisplay } from "actions/notification";
import { logger } from "utils/logger";

const BILLING_ERROR_MESSAGE =
  "Something went wrong. Please try again or contact support.";

export const checkoutSession = (payload) => async (dispatch) => {
  try {
    // unwrap() resolves with the thunk payload on success and throws on
    // rejection — so a failed checkout no longer silently dies on a
    // destructure of `undefined`.
    const { url } = await dispatch(checkoutSessionThunk(payload)).unwrap();
    if (url) {
      window.location = url;
    } else {
      dispatch(notificationDisplay("error", BILLING_ERROR_MESSAGE));
    }
  } catch (error) {
    logger.trace(error);
    dispatch(notificationDisplay("error", BILLING_ERROR_MESSAGE));
  }
};

export const customerPortal = (payload) => async (dispatch) => {
  try {
    const { url } = await dispatch(customerPortalThunk(payload)).unwrap();
    if (url) {
      window.location = url;
    } else {
      dispatch(notificationDisplay("error", BILLING_ERROR_MESSAGE));
    }
  } catch (error) {
    logger.trace(error);
    dispatch(notificationDisplay("error", BILLING_ERROR_MESSAGE));
  }
};

// TODO check this
export const subscriptionsList = (payload) => async (dispatch) => {
  try {
    await dispatch(subscriptionsListThunk(payload));
  } catch (error) {
    logger.trace(error);
  }
};
